import { gql } from "@apollo/client";
import { print } from "@apollo/client/utilities";

export const DELETE_QUERY = print(gql`
  mutation DeletePage($slug: String!) {
    deletePage(slug: $slug) {
      id
    }
  }
`);

export interface DeleteGql {
  deletePage: {
    id?: number;
  };
}
